import { PropType } from 'vue'
import { DraftType } from '../../hooks/draft-box'

export const gridTableProps = {

  /* 激活选项键 */
  activeTabKey: {
    type: String,
    default: ''
  },

  /** 标题 */
  title: String,

  /* 展示列表标题 */
  listTitleIsShow: {
    type: Boolean,
    default: false
  },

  /* 头部隐藏 */
  headerIsShow: {
    type: Boolean,
    default: true,
  },

  /** 增、删、改、查 */
  api: [Function, Object] as PropType<IGridTable.Api>,

  /** 列表搜索配置项 */
  searchSchemas: Array as PropType<IForm.Schema[]>,

  /** 列表请求额外参数 */
  getListApiParams: Object,

  /** 增、改 配置项 */
  formSchemas: Array as PropType<
    (IForm.Schema & {

      /** 仅在编辑时显示 */
      onlyEdit?: boolean;

      /** 仅在创建时显示 */
      onlyCreate?: boolean;
    })[]
  >,

  /** 列渲染配置项 */
  columnSchemas: {
    type: Array as PropType<IGridTable.ColumnProps[]>,
    required: true,
  },

  /** 表格操作 */
  tableActions: Array as PropType<IGridTable.Action[]>,

  /** 表格行操作 */
  rowActions: Array as PropType<IGridTable.RowAction[]>,

  immediate: {
    type: Boolean,
    default: true,
  },

  /** 是否展示行序号 */
  indexable: Boolean,

  /** 是否可以选择行 */
  selectable: Boolean,

  /** 是否可导出 */
  exportable: Boolean,
  disabledCurrentExport: Boolean,

  actionable: Boolean as PropType<boolean>, //
  /** 导出数据表格处理函数 */
  exportHandler: Function as PropType<(params: {
    tableHeader: string[],
    tableData: (string | number)[][],
    apiData: any[],
    filename: string,
  }) => Promise<void>>,

  /** 是否启用草稿功能 */
  draftable: String as PropType<DraftType>,

  /** 是否可以创建新数据 */
  creatable: {
    type: [Boolean, Function] as PropType<boolean | Fn>,
    default: () => false,
  },

  /** 创建新数据成功后的回调 */
  createdCallback: Function,

  /** 创建文字 */
  createText: String,

  /** 删除文字 */
  deleteText: String,

  /* 删除确认文字 */
  deleteConfirmText: String,

  /** 是否可以更新数据 */
  editable: {
    type: [Boolean, Function] as PropType<boolean | Fn>,
    default: () => false,
  },

  /** 数据编辑成功后的回调 */
  editedCallback: Function,

  /* 数据编辑的模型转换 */
  editModel: Function,

  /** 是否可以删除数据 */
  deleteable: {
    type: [Boolean, Function] as PropType<boolean | Fn>,
    default: () => false,
  },

  /** 数据删除成功后的回调 */
  deletedCallback: Function,

  modalWidth: Number as PropType<number>, //
}

export const tabGridTableProps = Object.assign({

  /* 选项列表 */
  tabList: {
    type: Array as PropType<Reference.ReferenceItem[]>,
    default: () => [],
  },

  /* 选项过滤入参 */
  tabValueField: {
    type: String,
    default: 'status',
  },

  /* 选项值类型 */
  tabValueIsArray: {
    type: Boolean,
    default: false,
  }
}, gridTableProps)
